"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelRank = exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel["Debug"] = "debug";
    LogLevel["Log"] = "log";
    LogLevel["Warn"] = "warn";
    LogLevel["Error"] = "error";
    /** None for showing no logs */
    LogLevel["None"] = "none";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
exports.LevelRank = {
    [LogLevel.Debug]: 0,
    [LogLevel.Log]: 1,
    [LogLevel.Warn]: 2,
    [LogLevel.Error]: 3,
    [LogLevel.None]: 100,
};
